import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  text-align: ${({ align }) => align};
  margin-bottom: 2rem;
`;

const Eyebrow = styled.span`
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 0.75rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  display: block;
  margin-bottom: 0.5rem;
`;

const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: clamp(1.75rem, 3vw, 2.5rem);
  margin: 0;
`;

const Description = styled.p`
  margin: 0.75rem 0 0;
  color: ${({ theme }) => theme.colors.textMuted};
  max-width: 640px;
`;

const SectionHeading = ({ eyebrow, title, description, align = 'left' }) => (
  <Wrapper align={align}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    {title && <Title>{title}</Title>}
    {description && <Description>{description}</Description>}
  </Wrapper>
);

export default SectionHeading;

